import api from '../utils/api';
import { USER_URL } from '../config/environment';
import axios from 'axios';

/**
 * Authentication Service
 * Handles all authentication-related API calls
 */

export const authService = {
  /**
   * User login
   * @param {string} email - User email
   * @param {string} password - User password
   * @returns {Promise<Object>} Login response with token and user data
   */
  login: async (email, password) => {
    const response = await api.post('/api/auth/login', { email, password });
    return response.data;
  },

  /**
   * User registration
   * @param {Object} userData - User registration data
   * @returns {Promise<Object>} Registration response
   */
  register: async (userData) => {
    const response = await api.post('/api/auth/account/register', userData);
    return response.data;
  },

  /**
   * Send password reset link
   * @param {string} email - User email
   * @returns {Promise<Object>} Reset link response
   */
  sendPasswordResetLink: async (email) => {
    const response = await axios.post(`${USER_URL}/api/auth/reset-password/send-link`, { email });
    return response.data;
  },

  /**
   * Confirm password reset
   * @param {Object} resetData - Reset data with token, email, and new password
   * @returns {Promise<Object>} Reset confirmation response
   */
  confirmPasswordReset: async (resetData) => {
    const response = await axios.post(`${USER_URL}/api/auth/reset-password/confirm`, resetData);
    return response.data;
  },

  /**
   * Verify email with token
   * @param {string} token - Token code
   * @returns {Promise<Object>} Verification response
   */
  verifyEmail: async (token) => {
    const response = await axios.get(`${USER_URL}/api/auth/email-verification/verify-link`, {
      params: { token }
    });
    return response.data;
  },

  /**
   * Send email verification link
   * @param {string} email - User email
   * @returns {Promise<Object>} Verification link response
   */
  sendEmailVerification: async (email) => {
    const response = await axios.post(`${USER_URL}/api/auth/email-verification/send-link`, { email });
    return response.data;
  },

  /**
   * Get account information
   * @returns {Promise<Object>} Account data
   */
  getAccount: async () => {
    const response = await axios.get(`${USER_URL}/api/auth/account`);
    return response.data;
  }
};

export default authService;
